import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { FlexLayoutModule } from "@angular/flex-layout";
import { TabViewModule } from "@bfx/primeng/tabview";
import { FieldsetModule } from "@bfx/primeng/fieldset";
import { PerfectScrollbarModule } from "@bfx/ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "@bfx/ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "@bfx/ngx-perfect-scrollbar";
import { TranslateModule } from "@ngx-translate/core";
import { BfxStrategyViewerComponent } from "./bfx-strategy-viewer.component";
import { BfxBlotterOrdersModule } from "../bfx-blotter-orders/bfx-blotter-orders.module";
import { BfxTradeBlotterModule } from "../bfx-blotter-trade/bfx-trade-blotter.module";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  imports: [
    CommonModule,
    PerfectScrollbarModule,
    FieldsetModule,
    FlexLayoutModule,
    FormsModule,
    TabViewModule,
    TranslateModule,
    BfxTradeBlotterModule,
    BfxBlotterOrdersModule,
  ],
  declarations: [BfxStrategyViewerComponent],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
  ],
  exports: [BfxStrategyViewerComponent],
  bootstrap: [BfxStrategyViewerComponent],
})
export class BfxStrategyViewerModule {}
